import {
  activity,
  activityb,
  Ajo,
  coi,
  coib,
  employ,
  employb,
  home,
  homeb,
  Lock,
  Man,
  more,
  moreb,
  msg,
  Naira,
  notification,
  notificationb,
  people,
  ques,
  Receipt,
  Referral,
  share,
  shareb,
  sms,
  woman,
} from "../../assets/exports";
import {
  FaIdCard,
  FaIdCardAlt,
  FaLock,
  FaPassport,
  FaUnlock,
  FaVoteYea,
} from "react-icons/fa";

export const data = [
  {
    id: 1,
    icon: home,
    blue: homeb,
    name: "Home",
    path: "/dashboard",
  },
  {
    id: 2,
    icon: coi,
    blue: coib,
    name: "Payment",
    path: "/payments",
  },
  {
    id: 3,
    icon: activity,
    blue: activityb,
    name: "Transaction",
    path: "/transactions",
  },
  {
    id: 4,
    icon: employ,
    blue: employb,
    name: "Employee Mgt",
    path: "/employee-mgt",
  },
  {
    id: 5,
    icon: notification,
    blue: notificationb,
    name: "Notifications",
    path: "/notifications",
  },
  {
    id: 7,
    icon: share,
    blue: shareb,
    name: "Referral",
    path: "/referrals",
  },
  { id: 8, icon: more, blue: moreb, name: "More", path: "/more" },
];

export const sideDrawer = [
  {
    id: 1,
    name: "Home",
    path: "/dashboard",
  },
  {
    id: 2,
    name: "Payment",
    path: "/payments",
  },
  {
    id: 3,
    name: "Transaction",
    path: "/transactions",
  },
  { id: 4, name: "Notifications", path: "/notifications" },
  {
    id: 5,
    name: "Referral",
    path: "/referrals",
  },
  { id: 7, name: "More", path: "/more" },
];

export const activeStyle = {
  backgroundColor: "#F3C948",
  color: "#fff",
  textAlign: "center",
  fontSize: "15px",
  fontWeight: "500",
  lineHeight: "10px",
  padding: "10px",
  borderRadius: "5%",
};

export const slideshow = [
  {
    id: 1,
    img: Receipt,
  },
  {
    id: 2,
    img: Lock,
  },
];

export const account = [
  {
    id: 1,
    name: "Transfer",
    bg: "#fff",
    route: "/account/transfer",
    hover: "#F3C948",
    img: Naira,
  },
  {
    depos: "depo",
    id: 2,
    name: "Deposit",
    bg: "#F3C948",
    hover: "#fff",
    img: Naira,
  },
  {
    id: 3,
    name: "Account Details",
    bg: "#7037C8",
    acc: "acc",
    hover: "#fff",
    color: "#fff",
    img: Naira,
  },
];

export const transactions = ["Transaction", "Cash inflow", "Cash outflow"];

export const settings = [
  "Profile Information",
  "Account Information",
  "Identity Verification",
  "Login & Security",
  "Help & Support",
];

export const verify = [
  {
    id: 1,
    title: "National Identification Number (NIN slip)",
    icon: FaIdCard,
  },
  {
    id: 2,
    title: "International Passport",
    icon: FaPassport,
  },
  {
    id: 3,
    title: "Voter's Card",
    icon: FaVoteYea,
  },
  {
    id: 4,
    title: "Driver's License",
    icon: FaIdCardAlt,
  },
];

export const trans = [
  "All Transactions",
  "Credit Transactions",
  "Debit Transactions",
];

export const test = [
  {
    id: 1,
  },
  {
    id: 2,
  },
  {
    id: 3,
  },
  {
    id: 4,
  },
];

export const notifi = ["All Notifications", "Read", "Unread"];

export const pay = [
  "Pending Payments",
  "Approved Payments",
  "Declined Payments",
];

export const details = ["Account Overview", "Signatory"];

export const depo = ["Bank Transfer", "USSD Code"];

export const employe = ["All Accounts", "Inactive Accounts", "Active Accounts"];

export const earn = [
  {
    id: 1,
    text: "You invite your friends/businesses",
  },
  {
    id: 2,
    text: "Friends/businesses register and make first 5 transactions",
  },
  {
    id: 3,
    opt: "opt",
    // text: "You earn ₦100 with no stress",
  },
];
export const images = [Referral, Ajo];
export const featured = [
  {
    id: 1,
    img: Referral,
    route: "",
  },
  {
    id: 1,
    img: Ajo,
  },
];

export const personalaccount = [
  {
    id: 1,
    icon: FaUnlock,
    main: "#F2F2F2",
    bg: "#F1EBF9",
    title: "BVN Verification Completed",
  },
  {
    id: 2,
    icon: FaLock,
    main: "#F1EBF9",
    title: "Verify ID",
    bg: "#fff",
    desc: "Verifying your identity gives you the power to use everything on FastaMoni.",
  },
];

export const pageSize = ["10", "20", "30", "40", "50"];

export const flowSise = ["All", "Last 7 days", "Last 14 days"];

export const duration = ["Custom duration", "Monthly"];

export const paymentHeader = [
  "",
  "Receiver Account Name",
  "Receiver Account Number",
  "Amount",
  "Status",
];

export const transHeader = [
  "",
  "Account Name",
  "Account Number",
  "Amount",
  "Date",
  "Status",
];

export const tranHeader = ["Account Name", "Amount", "Date", "Status"];

export const accounts = [
  {
    id: 1,
    title: "Ajo",
    route: `/create-account/${"ajo"}`,
    text: "Ideal for a group of people in a thrift organization.",
    img: woman,
  },
  {
    id: 2,
    title: "Couples",
    route: `/create-account/${"couple"}`,
    text: "For couples/partners who want to manage there joint account.",
    img: people,
  },
  {
    id: 3,
    title: "Project",
    route: `/create-account/${"project"}`,
    text: "Suitable for projects/events/crowdfunding.",
    img: Man,
  },
  {
    id: 4,
    title: "NGO",
    route: `/create-account/${"ngo"}`,
    text: "For NGO/NFPO organization which includes religious bodies and other civil societies.",
    img: woman,
  },
  {
    id: 5,
    title: "Business",
    route: `/create-account/${"business"}`,
    text: "Allows business owners manage there funds for accountability purposes.",
    img: woman,
  },
  {
    id: 6,
    title: "Estate Management",
    route: `/create-account/${"estate-mgt"}`,
    text: "Ideal for Private Estate Managers and  Community Development Association.",
    img: people,
  },
];

export const helps = [
  {
    id: 1,
    icon: msg,
    title: "Chat with us",
    text: "Start a conversation now",
  },
  {
    id: 2,
    icon: ques,
    title: "FAQs with us",
    route: "https://fastamoni.com/faq",
    text: "Find helpful answers instantly",
  },
  {
    id: 3,
    icon: sms,
    mail: "mail",
    title: "Email",
    text: "Get a solution mailed to your inbox",
  },
];
